import Comment from 'backbone/story/models/comment.js'

export default class StoryCommentCollection extends Backbone.Collection
  model: Comment

  comparator: (item) ->
    -Date.parse(item.get("thread_updated_at"))

  initialize: (options = {}) ->
    @storyId = options.storyId
    @fetched = false
    @listenTo(this, "sync reset", @onSyncReset)
    @fetchedCallbacks = []

  onFetched: (callback) ->
    if @fetched then callback() else @fetchedCallbacks.push(callback)

  onSyncReset: () =>
    @fetched = true
    while @fetchedCallbacks.length
      @fetchedCallbacks.pop()()

  url: ->
    if window.story.remote
      "/stories/#{@storyId}/comments/remote_approver_comments"
    else
      "/stories/#{@storyId}/comments"

  forVideoPlayer: (asset) ->
    @_forAsset(asset).map((comment) -> comment.toVideoAnnotation())

  forImage: (asset) ->
    @_forAsset(asset).map((comment) -> comment.toImageAnnotation())

  _forAsset: (asset) ->
    @filter((comment) -> comment.isAnnotatable(asset))

  removeActive: ->
    activeComment = @activeComment()
    activeComment.set(active: false) if activeComment

  activeComment: ->
    @where(active:true)[0]

  setActive: (comment) ->
    @removeActive()
    comment.set(active: true)



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/collections/comments/story_comments_collection.js.coffee